import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {StyledSubscriptionsPage} from './StyledSubscriptionsPage';
import SpinSmall from '../../components/SpinSmall';
import DashboardPageTransition from '../../components/animations/DashboardPageTransition';
import BalancePageHeader from '../../components/pages/TransactionsPage/BalancePageHeader';
import SubscriptionTabs from '../../components/pages/SubscriptionsPage/SubscriptionTabs';
import EmptySubscriptions from '../../components/pages/SubscriptionsPage/EmptySubscriptions';
import PageDocumentDetails from '../../components/PageDocumentDetails';
import PageContainer from '../../components/PageContainer';
import {mainActions} from '../../state/actions/main.actions';
import {subscriptionActions} from '../../state/actions/subscription.actions';
import {objectHelpers} from '../../utils/helpers';
import {useIsRequiredCardVerification} from '../../hooks';

const gObjProp = objectHelpers.getObjProp;

const SubscriptionsPage = ({
  getSubscriptionsTotal,
  getSubscriptionsViewsStatuses,
  openLightKycWindow,
}) => {
  const [t] = useTranslation(['subscriptions', 'main']);
  const [total, setTotal] = useState(null);
  const [loading, setLoading] = useState(true);

  const {required: isRequiredCardVerification} = useIsRequiredCardVerification();

  useEffect(() => {
    getSubscriptionsViewsStatuses();
  }, [getSubscriptionsViewsStatuses]);

  useEffect(() => {
    handleUpdateSubscriptionTotal();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const finishLoading = () => loading && setLoading(false);

  const handleUpdateSubscriptionTotal = () => {
    getSubscriptionsTotal(
      (data) => {
        setTotal({
          authorized: gObjProp(data, 'total_subscriptions_authorized', 0),
          deleted: gObjProp(data, 'total_canceled', 0),
          need_review: gObjProp(data, 'total_audited', 0),
          restricted: gObjProp(data, 'total_restricted', 0),
          unmanaged: gObjProp(data, 'total_unmanaged', 0),
          all: gObjProp(data, 'total_subscriptions_quantity', 0)
        });
        finishLoading();
      },
      finishLoading
    );
  }

  return (
    <PageContainer>
      <PageDocumentDetails title={t('main:pageTitles.subscriptionsList')} />
      <BalancePageHeader breadcrumbs={[{title: t('subscriptions')}]} />

      <DashboardPageTransition>
        <SpinSmall spinning={total === null && loading}>
          <StyledSubscriptionsPage>
            {isRequiredCardVerification ? (
              <EmptySubscriptions
                enableButton={true}
                onClick={openLightKycWindow}
                variant='banking'
              />
            ) : (
              <SubscriptionTabs
                handleUpdateSubscriptionTotal={handleUpdateSubscriptionTotal}
                total={total}
                totalLoading={loading}
              />
            )}
          </StyledSubscriptionsPage>
        </SpinSmall>
      </DashboardPageTransition>
    </PageContainer>
  );
}

const mapDispatchToProps = {
  getSubscriptionsTotal: subscriptionActions.getSubscriptionsTotal,
  getSubscriptionsViewsStatuses: subscriptionActions.getSubscriptionsViewsStatuses,
  openLightKycWindow: mainActions.openLightKycWindow
}

export default connect(null, mapDispatchToProps)(SubscriptionsPage);
